export const countries = {
  GETALL_COUNTRIES: 'GETALL_COUNTRIES',
  GETALL_COUNTRIES_SUCCESS: 'GETALL_COUNTRIES_SUCCESS',
  COUNTRY_REQUEST_ERROR: 'COUNTRY_REQUEST_ERROR',
};
